import { createSelector } from 'reselect';
import qs from 'querystring';

export const locationSelector = createSelector(
	state => state.router.location,
	location => location
);

export const pathNameSelector = createSelector(locationSelector, location => location.pathname);

export const challengeIdSelector = createSelector(
	pathNameSelector,
	(pathName) => {
		// TODO could probably use the search object from location also
		const { challengeId } = qs.parse(window.document.location.search.substring(1));
		return challengeId;
	}
);



// WEBPACK FOOTER //
// ./src/selectors/router.js